export const Loading = ({classes}) => {
  return (
    <div className="flex items-center justify-center ">
      <span className={`loader ${classes}`}></span>
    </div>
  );
};
